export { BONUS_BY_PRODUCT_CARDS_EN_US } from "./bonus-by-product-cards-en-us";
export { BONUS_BY_PRODUCT_CARDS_ES_MX } from "./bonus-by-product-cards-es-mx";
export { BONUS_BY_PRODUCT_CARDS_FR_FR } from "./bonus-by-product-cards-fr-fr";
export { BONUS_BY_PRODUCT_CARDS_PT_BR } from "./bonus-by-product-cards-pt-br";
export type { BonusByProductCardsTranslations } from "./bonus-by-product-cards-pt-br";
